import type { ReactNode } from "react";

/**
 * Covers the whole viewport, sidebar included: it renders both outside the app
 * shell (the OAuth round trip) and inside it (ProtectedRoute), and in the
 * second case there is no session to operate the shell with.
 */
export function FullPageStatus({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background p-6 text-center text-foreground">
      <div className="max-w-sm">
        <p className="text-lg font-semibold text-foreground">{title}</p>
        {description && (
          <p className="mt-1 text-sm text-foreground">{description}</p>
        )}
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  );
}
